<template>
    <article class="doc-article">
		<p>欢迎你使用动态时序官网！</p>
		<p>为使用动态时序官网认证服务（以下简称“本服务”），你应当阅读并遵守《动态时序官网认证服务协议》（以下简称“本协议”），以及《动态时序官网用户服务协议》、《动态时序官网隐私政策》以及专项规则等。请务必审慎阅读、充分理解各条款内容，特别是免除或限制责任的相应条款，以及开通或使用某项服务的单独协议，并选择接受或不接受。</p>
		<p>除非你已阅读并接受本协议所有条款，否则你无权使用动态时序官网服务。你对本服务的登录、查看、发布信息等行为即视为你已阅读并同意本协议的约束。如果你未满18岁，请在法定监护人的陪同下阅读本协议及其他上述协议，并特别注意未成年人使用条款。</p>
		<h5>1.协议的范围</h5>
		<p>1.1.【协议适用主体范围】</p>
		<p>本协议你与动态时序之间关于你使用动态时序官网认证服务所订立的协议。“动态时序”是指动态时序公司及其相关服务可能存在的运营关联单位。“用户”是指申请动态时序官网认证服务及/或已经认证成功的动态时序的用户，在本协议中更多地称为“你”。</p>
		<p>1.2.【协议关系及冲突条款】</p>
		<p>本协议被视为《动态时序官网用户服务协议》及《动态时序官网隐私政策》的补充协议，是其不可分割的组成部分，与其构成统一整体。本协议与上述内容存在冲突的，以本协议为准。</p>
		<p>本协议内容同时包括动态时序可能不断发布的关于本服务的相关协议、服务声明、业务规则及公告指引等内容（以下统称为“专项规则”）。上述内容一经正式发布，即为本协议不可分割的组成部分，你同样应该遵守。</p>
		<h5>2.术语定义</h5>
		<p>2.1.动态时序官网认证服务：是指符合一定条件的用户可以对动态时序官网账号申请及其提交的资料和信息进行审核，并根据审核情况确定认证结果和认证信息的服务。</p>
		<p>2.2.认证审核：指用户向动态时序提出申请，动态时序根据法律规定及双方的约定和保证，基于用户提交的资料和信息，对用户的动态时序官网账号进行账号资质审核和账号名称审核。</p>
		<p>2.2.1.账号资质审核：指用户向动态时序提出申请，动态时序根据法律规定及双方的约定和保证，对用户提交的主体资质证明或其所拥有的权利证明资料和信息进行甄别及核实的过程。</p>
		<p>2.2.2.账号名称审核：指用户向动态时序提出申请，动态时序根据法律规定及双方的约定和保证，对用户账号名称进行审查核定的过程。</p>
		<p>2.3.认证结果：是指动态时序按照用户的申请进行认证审核后，动态时序向用户输出的认证结果，认证结果指包括认证通过和认证未通过两种情形。</p>
		<p>2.4.认证通过：指动态时序对用户提交的资料和信息进行甄别及核实，在完成所有审核流程后，由动态时序作出认证通过的判断。针对认证通过的用户，动态时序将根据本协议确定用户的认证账号名称，生成认证标识及认证信息。认证通过可获得申请开通相应的高级功能及高级权限的资格，但具体开通范围、标准等事宜，由动态时序官网制定和执行。未按期完成年审认证或年审认证未通过的用户不属于认证成功用户。</p>
		<p>2.5.系统通知用户调整申请内容：指用户在申请认证过程中，因不满足认证成功条件，而被动态时序以系统通知的方式要求作调整或补充的情形。</p>
		<p>2.6.认证未通过：指动态时序对用户的资料进行甄别及核实，在完成所有审核流程后，由动态时序作出认证未通过判断，包括但不限于以下任一情形：</p>
		<p>2.6.1.由于用户原因，经动态时序三次系统通知用户调整申请内容，用户仍未能满足账号认证要求的；</p>
		<p>2.6.2.因其他原因而不能认证成功的情形。</p>
		<h5>3.用户的权利和义务</h5>
		<p>3.1.用户应保证其提供给动态时序的所有资料和信息的真实性、合法性、准确性和有效性。如用户提供服务或内容需要取得相关法律法规的许可或进行备案的，用户应当主动进行明确说明并提交相应的许可或备案证明。否则，动态时序有权拒绝或终止提供本服务，并依照本协议对违规账号进行处罚。因此给动态时序造成损害的，你应当依法予以赔偿。</p>
		<p>3.2.用户同意授权动态时序对其提交的资料进行甄别核实，动态时序有权出于认证审核之必要查阅、使用及保存上述资料及信息，并有权与用户就认证审核事宜进行联系与沟通，用户应当配合动态时序认证审核过程中所提出的相关需求。</p>
		<p>3.3.用户不得通过非动态时序的其他任何渠道使用本服务，如非因动态时序原因导致的认证失败、认证流程过长等后果，动态时序不承担责任。</p>
		<p>3.4.用户理解并且同意，用户提交的资料和信息是作出认证结果的重要依据，任何资料和信息的变更将可能影响认证结果，用户应当在资料和信息变更时及时提出补充认证申请，否则动态时序有权依照本协议约定对用户进行处罚。动态时序因此遭受损失的，你也应当一并赔偿。</p>
		<p>3.5.账号认证审核成功后，用户具备申请为其开通高级功能的资格，但高级功能的开通范围、标准等事宜，由动态时序官网制定和执行，用户使用高级功能时应遵守法律、行政法规和本协议或相关服务条款的规定，否则，动态时序有权不经通知随时视行为情节对违规用户的账号采取包括但不限于限制、停止使用高级功能等措施。</p>
		<h5>4.动态时序的权利义务</h5>
		<p>4.1.保护用户信息是动态时序的一项基本原则，动态时序将会采取合理的措施保护用户所提交的一切资料及信息。除法律法规规定的情形外，未经用户许可动态时序不会向其他第三方公开、透露上述资料及信息。用户基于申请本服务的需要，授权动态时序对其提交的资料进行甄别核实，在法律、法规或监管部门的要求下，还需将用户提交的资料和信息递交至相关政府部门或其委托的机构进行审核、备案，在本协议许可的范围内，动态时序对相关资料及信息采用专业加密存储与传输方式进行传输及使用，保障用户的信息安全。</p>
		<p>4.2.为依法保障动态时序官网认证服务的规范有序，动态时序有权根据相关法律法规的规定及行业标准，针对用户的不同认证需求制定不同的认证审核标准及要求进行修改。</p>
		<p>4.3.动态时序有权根据用户提交的资料及信息确定审核结果，对符合动态时序官网所制定的范围和标准等的账号，准予其提交的开通相应的高级功能或高级权限的申请。</p>
		<h5>5.认证服务规范</h5>
		<p>5.1.【认证流程】</p>
		<p>5.1.1.用户申请本服务需要登录申请页面按照动态时序提示提交有关资料及信息。你在申请本服务时应仔细阅读并同意本协议，你对本服务的接受、提交资料和信息等行为即视为你已阅读并同意受本协议的约束。</p>
		<p>5.1.2.用户在完成在线申请及资料提交流程，动态时序会在3个工作日内展开审核工作，用户应积极配合动态时序的审核需求，并有权随时了解、查询审核进度。</p>
		<p>5.1.3.用户同意动态时序对其提交的资料和信息进行甄别核实，并在完成所有审核流程后，由动态时序独立作出账号认证成功或者认证失败的判断，并以前述判断为依据确定用户是否具备申请开通高级功能及高级权限的资格等，用户应当予以配合。</p>
		<p>5.1.4.审核完成后，动态时序将反馈以下审核结果：</p>
		<p>5.1.4.1.账号认证审核成功，用户获得向动态时序申请开通高级功能的资格；</p>
		<p>5.1.4.2.账号认证审核成功，动态时序将作出认证成功判断，确定用户的认证账号名称，生成认证标识及认证信息，获得申请开通相应的高级功能及高级权限的资格；</p>
		<p>5.1.4.3.认证失败，动态时序将告知用户失败的原因。</p>
		<p>5.1.5.审核成功用户应根据以下条款申请年审认证：</p>
		<p>5.1.5.1.用户认证审核成功后账号审核成功能状态将会保留一年（起算日为账号认证提交日）。用户如需保留账号审核成功状态，保持所具备的申请、继续使用高级功能的资格，则应自账号资质审核成功之日起一年内发起并完成年审认证，年审认证流程及认证审核标准与原认证审核一致。如用户未能及时完成年审认证或者账号资质审核失败，其账号审核成功状态终止，已经开通的高级功能、高级权限使用权将被取消，申请开通高级功能、高级权限的资格也将被取消。</p>
		<p>5.1.6.用户向动态时序提供的资料和信息如有变更的，应当及时采取以下措施：</p>
		<p>5.1.6.1.如处于认证审核过程中的资料和信息发生变更，用户应立即通知动态时序更新有关资料及信息；</p>
		<p>5.1.6.2.如认证成功后资料和信息发生变更，用户应及时申请补充订单变更有关资料及信息；</p>
		<p>5.1.6.3.如认证成功动态时序发现资料和信息存在错误，用户应及时申请补充订单更正有关资料及信息。</p>
		<p>5.2.【认证规则】</p>
		<p>5.2.1.用户理解并同意：动态时序官网认证服务内容仅限于对用户提交的资料及信息进行甄别与核实，动态时序将对前述资料及信息进行合理、谨慎的形式审查，但在动态时序的合法权限和合理能力范围内，动态时序无法实质审查用户的实际经营、运营以及推广等行为，并不为此提供任何担保。</p>
		<p>5.2.2.动态时序有权甄别核实包括但不限于以下内容：</p>
		<p>5.2.2.1.用户是否拥有合法主体资质，以及是否取得提供服务或内容相应的权利或授权；</p>
		<p>5.2.2.2.其他动态时序人为需要审核的内容。用户应就上述内容提供相应的证明文件予以证明并承担真实性、合法性、准确性的瑕疵担保责任。</p>
		<p>5.3.认证信息内容由动态时序根据审核情况进行确定，并在认证账号审核成功后生成，主要包括用户主体资质和权利等可有效证明的信息。动态时序有权根据官网规范运营的需要调整认证信息的内容及格式。</p>
		<p>5.4.为保障动态时序官网安全运营及开放平台其他用户的合法权益，若动态时序发现或经他人举报用户的账号存在任何违反法律法规、《动态时序官网用户协议》及本协议等各项规范规则情况，或动态时序人为经第三方通知用户的账号存在或可能存在上述情况，不管该账号是否已经认证成功，动态时序均有权采取拒绝提供年审认证服务等方式停止为该用户提供本服务。</p>
		<h5>6.法律责任</h5>
		<p>6.1.如果动态时序发现或收到他人投诉用户违反法律法规、《动态时序官网用户协议》或本协议约定的，动态时序有权不经通知随时视行为情节对违规用户的账号处以包括但不限于拒绝提供本服务、终止本服务资质审核、责令用户补充资质审查资料、责令用户修改认证信息、责令用户再次申请认证、强制修改账号名称及认证信息直至取消认证等措施。</p>
		<p>6.2.用户理解并同意，因用户违反本协议或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，用户应当独立承担责任；动态时序因此遭受损失的，用户也应当一并赔偿。</p>
		<h5>7.其他</h5>
		<p>7.1.你使用本服务即视为你已阅读并同意受本协议的约束。动态时序有权在必要时修改本协议条款。你可以在相关服务页面查阅最新版本的条款。本协议条款变更后，如果你继续使用动态时序官网认证服务，即视为你已接受修改后的协议。如果你不接受修改后的协议，应当停止使用动态时序官网认证服务。</p>
		<p>7.2.本协议签订地位中华人民共和国北京市海淀区。</p>
		<p>7.3.本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律。</p>
		<p>7.4.若你和动态时序之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，你同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。</p>
		<p>7.5.本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。</p>
		<p>7.6.本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。</p>
		<p>7.7.你在使用本服务过程中，如发现相关内容存在违反相关法律法规或侵犯了你的权利，请及时向我们举报或反馈，我们将依法处理。</p>
		<router-view></router-view>
    </article>
</template>
<script>
export default {
    namme:'case1',
    data(){
        return{
            
        }
    },
    methods:{
       
    },
    mounted(){
       this.$store.commit('setAboutIndex',3)
    }
}
</script>
<style lang="less" scoped>
	/* 协议正文排版：handoff 文档样式（标题层级 + 正文行高），正文内容未做任何改动 */
	.doc-article {
		padding: 38px 44px 10px;
		background: #fff;
		border: 1px solid #E8EBF0;
		border-radius: 14px;
		h5 {
			font-size: 17px;
			font-weight: 700;
			color: #111827;
			margin: 26px 0 10px;
		}
		p {
			font-size: 14.5px;
			line-height: 1.9;
			color: #374151;
			margin-bottom: 10px;
		}
		a {
			color: #1A56DB;
			word-break: break-all;
		}
		a:hover {
			text-decoration: underline;
		}
	}
	@media (max-width: 620px) {
		.doc-article {
			padding: 24px 20px 4px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/aboutUs/caseChild/case4.vue